export function getPaginationData(headers) {
  return {
    totalCount: +headers["x-pagination-total-count"] || 1,
    pageCount: +headers["x-pagination-page-count"] || 1,
    currentPage: +headers["x-pagination-current-page"] || 1,
    perPage: +headers["x-pagination-per-page"] || 1
  };
}

export function toQueryString(obj) {
  const str = Object.keys(obj)
    .filter(function(key) {
      if (Array.isArray(obj[key])) {
        return !!obj[key].length;
      } else {
        return (
          typeof obj[key] !== "undefined" &&
          obj[key] !== null &&
          obj[key] !== ""
        );
      }
    })
    .map(function(key) {
      if (Array.isArray(obj[key])) {
        return obj[key].map(item => key + "[]=" + item).join("&");
      } else {
        return key + "=" + obj[key];
      }
    })
    .join("&");
  return encodeURI(str);
}

export function toFormData(data) {
  const formData = new FormData();

  for (let key in data) {
    const value = data[key];
    if (value === null || value === undefined) continue;
    if (Array.isArray(value)) {
      value.forEach(item => formData.append(`${key}[]`, item));
    } else {
      formData.append(key, value);
    }
  }

  return formData;
}

export const multipartHeaders = {
  "Content-Type": "multipart/form-data"
};
